import React from 'react';
import { connect } from 'react-redux';
import './StandByNextStepCard.scss';

class StandByNextSteps extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { title, description, icon } = this.props;
        return (
            <div className="standByNextStepCard">
                <div className="standByNextStepCard__image-container">
                    <div className="standByNextStepCard__round-icon-container">
                        <img src={icon} alt="icon-iban" />
                    </div>
                </div>
                <div className="standByNextStepCard__text-container">
                    <p>{title}</p>
                    <p>{description}</p>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    userProfile: state.userProfile,
    options: state.options,
    userProfileForm: state.userProfileForm,
}))(StandByNextSteps);
